export default {
  payableAmount: 'مبلغ قابل پرداخت',
  commission: 'کمیسیون',
  courierShare: 'سهم پروژه',
  driverShare: 'سهم راننده',
  pricingType: 'نوع قیمت دهی',
  state: 'وضعیت',
  isPaid: 'پرداخت شده ؟',
  creationTime: 'تاریخ ثبت',
  configPayment: 'تنظیمات',
  shebaNumber: 'شماره شبا',
  payTo: 'پرداخت به {title}',
  add: 'اضافه کردن',
  driver: 'راننده',
  badpa: 'بادپا',
  areYouSureYouWantToPayBelowItems: 'از پرداخت موراد زیر اطمینان دارید؟',
  acceptPayment: 'تایید پرداخت',
  originBankAccount: 'حساب بانکی مبدا',
  badpaShare: 'سهم بادپا',
  range: 'محدوده',
  facilitiesType: 'نوع تسهیلات',
  depositNumber: 'شماره سپرده',
  installmentsCount: 'تعداد اقساط',
  bankCreditType: 'نوع تسهیلات'
}
